import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
export default function Login() {
  const { login } = useAuth(); const navigate = useNavigate();
  const [email, setEmail] = useState(''); const [password, setPassword] = useState('');
  const [error, setError] = useState(''); const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => { e.preventDefault(); setError(''); setLoading(true); try { await login(email, password); navigate('/'); } catch (err) { setError(err.response?.data?.detail || 'Login failed.'); } finally { setLoading(false); } };
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0f2460 0%, #1a3a8f 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>💰</div>
          <h1 style={{ color: 'white', fontSize: 28, fontFamily: 'Space Grotesk, sans-serif' }}>FinTrack</h1>
          <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 14, marginTop: 4 }}>Personal Finance Tracker</p>
        </div>
        <div className="card" style={{ padding: 32 }}>
          <h2 style={{ fontSize: 18, marginBottom: 24 }}>Sign In</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group"><label className="form-label">Email</label><input className="form-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" required autoFocus /></div>
            <div className="form-group"><label className="form-label">Password</label><input className="form-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required /></div>
            {error && <div style={{ background: '#fee2e2', color: '#991b1b', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>{error}</div>}
            <button className="btn btn-primary w-full" type="submit" disabled={loading} style={{ justifyContent: 'center', padding: '11px 16px', fontSize: 15 }}>{loading ? 'Signing in…' : 'Sign In'}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
